import { render, staticRenderFns } from "./PosterCard.vue?vue&type=template&id=a30990b4&scoped=true&"
import script from "./PosterCard.vue?vue&type=script&lang=js&"
export * from "./PosterCard.vue?vue&type=script&lang=js&"
import style0 from "./PosterCard.vue?vue&type=style&index=0&id=a30990b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30990b4",
  null
  
)

export default component.exports